// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import vuetify from '@/plugins/vuetify'
import VeeValidate from 'vee-validate'
import moment from 'moment'
import App from './App'
import { router } from './components/_router/router'
import { store } from './components/_store'
import SnackbarWidget from './components/Helpers/SnackbarWidget.vue'

// TODO: service worker for the PWA, will be here for when we decide we want it
import './registerServiceWorker'

//import styles here instead of App.vue for better performance, and to keep all config info in one spot
import './style/style.scss'

// Defining events as '' makes it so we only validate fields manually.
// This prevents errors from displaying on a field the moment someone types anything in it.
// For instance, email fields will be automatically incorrect until they find a valid string
// Aka only when the user has finished typing.
// It's a poor user experience to tell the user they are wrong before they are even finished doing something.
Vue.use(VeeValidate, {
    events: ''
})
Vue.component('snackbar-widget-helper', SnackbarWidget)
window.moment = moment
Vue.config.productionTip = false
new Vue({
    vuetify,
    router,
    store,
    render: function(h) {
        return h(App)
    }
}).$mount('#app')
